// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1qtxm","savePackageButton":"ClientWallet_savePackageButton__3ppSr"};